import React from "react";
import LoadingOverlay from "react-loading-overlay";
import styled from "styled-components";
import Lottie from "react-lottie";
import ombreLoader from "../../assets/lottie/ombre-loading.json";

const Loading = ({ active, text, children }) => {
  const StyledLoader = styled(LoadingOverlay)`
    width: auto;
    height: auto;
    font-weight: bold;
    font-family: Playfair Display;
    .MyLoader_overlay {
      background: rgba(0, 0, 0, 0.9);
      position: fixed;
    }
    &.MyLoader_wrapper--active {
      overflow: hidden;
    }
  `;

  return (
    <StyledLoader
      fadeSpeed={5000}
      active={active}
      text={text}
      classNamePrefix="MyLoader_"
      spinner={<Loader />}
    >
      {children}
    </StyledLoader>
  );
};

const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ombreLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Lottie
      style={{ marginBottom: "20px" }}
      options={defaultOptions}
      height={40}
      width={40}
    />
  );
};

export default Loading;
